/* Native links and GET forms work without JavaScript. Enhance only this collection. */
if (!customElements.get('sg-holiday-collection')) {
  customElements.define('sg-holiday-collection', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.enhance();
      this.addEventListener('click', event => {
        const opener = event.target.closest('.sg-holiday-mobile-filter');
        if (opener) return this.openDrawer(opener);
        if (event.target.closest('.sg-holiday-filter-close, .sg-holiday-filter-backdrop')) return this.closeDrawer();
        if (event.target.closest('.sg-holiday-drawer-clear')) {
          const form = this.querySelector('.sg-holiday-filter-form');
          form.querySelectorAll('input:not([name=sort_by])').forEach(input => {
            if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
            else input.value = '';
          });
          this.previewCount(form);
          return;
        }
        const clear = event.target.closest('[data-filter-clear]');
        if (clear) {
          event.preventDefault();
          clear.closest('details').querySelectorAll('input').forEach(input => {
            if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
            else input.value = '';
          });
          return;
        }
        const summary = event.target.closest('.sg-holiday-filter > summary');
        if (summary && this.querySelector('[data-open]')) {
          this.querySelectorAll('.sg-holiday-filter[open]').forEach(details => {
            if (details !== summary.parentElement) details.open = false;
          });
        }
        if (summary && !this.querySelector('[data-open]')) {
          const current = summary.parentElement;
          this.querySelectorAll('.sg-holiday-filter[open]').forEach(details => {
            if (details !== current) this.dismissFilter(details);
          });
          if (current.open) this.resetFilter(current);
        }
        const link = event.target.closest('a[data-holiday-link]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const url = new URL(link.href);
        if (url.origin !== location.origin || url.pathname !== new URL(this.dataset.url, location.origin).pathname) return;
        event.preventDefault();
        this.load(url, true);
      }, options);
      this.addEventListener('submit', event => {
        if (!event.target.matches('.sg-holiday-filter-form')) return;
        event.preventDefault();
        this.apply(event.target);
      }, options);
      this.addEventListener('change', event => {
        const form = event.target.closest('.sg-holiday-filter-form');
        if (event.target.matches('[data-price-min]')) {
          const group = event.target.closest('details');
          group.querySelector('[name$=".gte"]').value = event.target.dataset.priceMin === '0' ? '' : event.target.dataset.priceMin;
          const maxInput = group.querySelector('[name$=".lte"]');
          maxInput.value = event.target.dataset.priceMax ? Math.min(Number(event.target.dataset.priceMax), Number(maxInput.max)) : '';
        } else if (event.target.matches('.sg-holiday-price-fields input')) {
          event.target.closest('details').querySelectorAll('[data-price-min]').forEach(input => { input.checked = false; });
        }
        if (form?.hasAttribute('data-open')) this.previewCount(form);
        if (form && event.target.name === 'sort_by' && !matchMedia('(max-width: 749px)').matches) this.apply(form);
      }, options);
      this.addEventListener('keydown', event => {
        const drawer = this.querySelector('[data-open]');
        if (!drawer) {
          if (event.key === 'Escape') {
            const details = event.target.closest('.sg-holiday-filter[open]');
            if (details) { event.preventDefault(); this.dismissFilter(details); details.querySelector('summary').focus(); }
          }
          return;
        }
        if (event.key === 'Escape') { event.preventDefault(); this.closeDrawer(); }
        if (event.key !== 'Tab') return;
        const controls = [...drawer.querySelectorAll('button, input, select, summary, a[href]')].filter(el => !el.disabled && el.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      document.addEventListener('click', event => {
        if (this.querySelector('[data-open]')) return;
        this.querySelectorAll('.sg-holiday-filter[open]').forEach(details => {
          if (!details.contains(event.target)) this.dismissFilter(details);
        });
      }, options);
      window.addEventListener('popstate', () => this.load(new URL(location.href), false), options);
      this.breakpoint = matchMedia('(max-width: 749px)');
      this.breakpoint.addEventListener('change', () => this.closeDrawer(), options);
    }
    disconnectedCallback() { this.events?.abort(); this.pending?.abort(); this.countRequest?.abort(); clearTimeout(this.countTimer); this.unlock(); }
    enhance() {
      this.querySelector('.sg-holiday-filter-form')?.setAttribute('data-enhanced', '');
      this.querySelectorAll('.sg-holiday-mobile-filter').forEach(button => button.setAttribute('data-enhanced', ''));
      this.querySelectorAll('[data-price-min]').forEach(input => {
        const group = input.closest('details');
        input.disabled = Number(input.dataset.priceMin) > Number(group.querySelector('[name$=".gte"]').max);
        const min = group.querySelector('[name$=".gte"]').value || '0';
        const max = group.querySelector('[name$=".lte"]').value;
        input.checked = Number(min) === Number(input.dataset.priceMin) && (max === '' ? !input.dataset.priceMax : Number(max) === Number(input.dataset.priceMax));
        input.defaultChecked = input.checked;
      });
    }
    resetFilter(details) {
      details.querySelectorAll('input').forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') input.checked = input.defaultChecked;
        else input.value = input.defaultValue;
      });
    }
    dismissFilter(details) { this.resetFilter(details); details.open = false; }
    openDrawer(opener = this.querySelector('.sg-holiday-mobile-filter')) {
      const form = this.querySelector('.sg-holiday-filter-form');
      if (form.hasAttribute('data-open')) return;
      this.drawerOpener = opener;
      this.drawerValues = [...form.querySelectorAll('input[type=checkbox]')].map(input => ({input, disabled:input.disabled, count:input.closest('label').querySelector('.sg-holiday-option-count')?.textContent}));
      this.setAttribute('data-sg-drawer-open', '');
      form.querySelectorAll('details').forEach(details => { details.open = false; });
      const firstGroup = opener.dataset.openFilter === 'sort' ? form.querySelector('.sg-holiday-sort-menu') : form.querySelector('[style*="--sg-filter-order:1"]') || form.querySelector('.sg-holiday-filters details');
      if (firstGroup) firstGroup.open = true;
      form.setAttribute('data-open', '');
      form.setAttribute('role', 'dialog');
      form.setAttribute('aria-modal', 'true');
      opener.setAttribute('aria-expanded', 'true');
      this.setCount(this.dataset.productsCount);
      this.updateDrawerClear(form);
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inertElements = [];
      for (let branch = form; branch.parentElement && branch !== document.body; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) {
          if (sibling !== branch && !sibling.matches('.sg-holiday-filter-backdrop') && !sibling.inert) {
            sibling.inert = true;
            this.inertElements.push(sibling);
          }
        }
      }
      form.querySelector('.sg-holiday-filter-close').focus();
    }
    unlock() {
      this.inertElements?.forEach(element => { element.inert = false; });
      this.inertElements = [];
      if (this.savedOverflow !== undefined) {
        document.body.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
      }
    }
    closeDrawer() {
      const form = this.querySelector('.sg-holiday-filter-form');
      if (!form?.hasAttribute('data-open')) return;
      this.countRequest?.abort();
      clearTimeout(this.countTimer);
      this.removeAttribute('data-sg-drawer-open');
      form.reset();
      this.drawerValues?.forEach(({input,disabled,count}) => {
        input.disabled = disabled;
        const label = input.closest('label').querySelector('.sg-holiday-option-count');
        if (label) label.textContent = count;
      });
      this.drawerValues = null;
      form.querySelectorAll('details[open]').forEach(details => { details.open = false; });
      form.removeAttribute('data-open');
      form.removeAttribute('role');
      form.removeAttribute('aria-modal');
      this.unlock();
      const opener = this.drawerOpener || this.querySelector('.sg-holiday-mobile-filter');
      this.querySelectorAll('.sg-holiday-mobile-filter').forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (opener.getClientRects().length) opener.focus();
    }
    formURL(form) {
      const url = new URL(form.action);
      for (const [key, value] of new FormData(form)) if (value !== '' && key !== 'holiday_price_range') url.searchParams.append(key, value);
      return url;
    }
    apply(form) { this.load(this.formURL(form), true); }
    setCount(count) {
      const button = this.querySelector('.sg-holiday-show-results');
      if (!button) return;
      button.disabled = false;
      button.textContent = count == null ? 'Show results' : `Show ${count} ${Number(count) === 1 ? 'result' : 'results'}`;
    }
    updateDrawerClear(form) {
      const clear = form.querySelector('.sg-holiday-drawer-clear');
      const hasFilters = [...new FormData(form)].some(([key, value]) => key.startsWith('filter.') && value !== '');
      if (clear) clear.hidden = !hasFilters;
    }
    previewCount(form) {
      this.updateDrawerClear(form);
      clearTimeout(this.countTimer);
      this.countRequest?.abort();
      const pending = new AbortController();
      this.countRequest = pending;
      const button = this.querySelector('.sg-holiday-show-results');
      button.textContent = 'Updating…';
      button.disabled = true;
      this.countTimer = setTimeout(async () => {
        const url = this.formURL(form);
        url.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(url, {signal: pending.signal});
          if (!response.ok) throw new Error('Count unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = [...doc.querySelectorAll('sg-holiday-collection')].find(el => el.dataset.sectionId === this.dataset.sectionId);
          if (!replacement) throw new Error('Count unavailable');
          if (pending.signal.aborted || !form.hasAttribute('data-open')) return;
          this.setCount(replacement.dataset.productsCount);
          const nextInputs = [...replacement.querySelectorAll('input[type=checkbox]')];
          form.querySelectorAll('input[type=checkbox]').forEach(input => {
            const next = nextInputs.find(other => other.name === input.name && other.value === input.value);
            input.disabled = !input.checked && (!next || next.disabled);
            const count = input.closest('label').querySelector('.sg-holiday-option-count');
            if (count) count.textContent = next?.closest('label').querySelector('.sg-holiday-option-count')?.textContent || '(0)';
          });
        } catch(error) {
          if (error.name !== 'AbortError' && !pending.signal.aborted) this.setCount(null);
        }
      }, 200);
    }
    async load(url, push) {
      this.pending?.abort();
      const pending = new AbortController();
      this.pending = pending;
      this.closeDrawer();
      this.setAttribute('aria-busy', 'true');
      const request = new URL(url);
      request.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(request, { signal: pending.signal });
        if (!response.ok) throw new Error('Collection could not load');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = [...doc.querySelectorAll('sg-holiday-collection')].find(el => el.dataset.sectionId === this.dataset.sectionId);
        if (!replacement) throw new Error('Collection missing');
        this.dataset.productsCount = replacement.dataset.productsCount;
        this.innerHTML = replacement.innerHTML;
        this.enhance();
        if (push) history.pushState({}, '', url);
        const status = this.querySelector('.sg-holiday-result-count');
        status?.focus({ preventScroll: true });
        status?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      } catch (error) {
        if (error.name !== 'AbortError') location.assign(url.href);
      } finally {
        if (this.pending === pending) this.removeAttribute('aria-busy');
      }
    }
  });
}

/* Keep native swipe scrolling; arrows progressively enhance mobile product rows. */
if (!customElements.get('sg-holiday-carousel')) {
  customElements.define('sg-holiday-carousel', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.sg-holiday-products--rail');
      if (!this.rail) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.update = () => {
        const remaining = this.rail.scrollWidth - this.rail.clientWidth - this.rail.scrollLeft;
        this.querySelector('[data-direction="-1"]').disabled = this.rail.scrollLeft <= 1;
        this.querySelector('[data-direction="1"]').disabled = remaining <= 1;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        const card = this.rail.querySelector('.sg-holiday-card');
        const step = (card?.getBoundingClientRect().width || this.rail.clientWidth) + parseFloat(getComputedStyle(this.rail).gap || 0);
        this.rail.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.rail.addEventListener('scroll', this.update, options);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.rail);
      this.setAttribute('data-enhanced', '');
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
    }
  });
}

if (!customElements.get('sg-coupon-price')) {
  customElements.define('sg-coupon-price', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.scope = this.closest('[data-product-id]') || this.closest('.shopify-section');
      if (!this.scope) return;
      this.scope.addEventListener('change', event => {
        if (!event.target.matches('.formVariantId, select[name="id"], input[name="id"]')) return;
        const id = String(event.target.value);
        const rows = [...this.querySelectorAll('[data-coupon-variant]')];
        if (!rows.some(row => row.dataset.couponVariant === id)) return;
        rows.forEach(row => { row.hidden = row.dataset.couponVariant !== id; });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
